import React from 'react';
import { ShieldCheck, BookOpenCheck, FlaskConical, Library } from 'lucide-react';
import { TOKENS, displayFont } from '../../lib/designTokens';

// CRO Audit §3.3 #4 + §5.3 step 2 — trust bar directly under the hero.
// Conveys editorial policy, scientific rigor, and external citations at-a-glance.
const TRUST_ITEMS = [
  { icon: ShieldCheck, label: 'Editorial policy', detail: 'How we source & verify' },
  { icon: BookOpenCheck, label: 'PubMed-cited', detail: '200+ peer-reviewed sources' },
  { icon: FlaskConical, label: 'Protocol library', detail: '40+ peptide guides' },
  { icon: Library, label: 'Guide library', detail: 'Training, recovery & performance' },
];

export const TrustBar = () => (
  <section
    className="border-t border-b"
    style={{ borderColor: 'rgba(255,255,255,0.06)', backgroundColor: TOKENS.surface1 }}
    data-testid="trust-bar-section"
  >
    <div className="container-ninja">
      <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-zinc-800/60">
        {TRUST_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <div
              key={item.label}
              className="flex items-center gap-3 px-3 md:px-6 py-5"
              data-testid={`trust-item-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <Icon
                className="w-5 h-5 flex-shrink-0"
                style={{ color: TOKENS.lime }}
                strokeWidth={1.5}
              />
              <div>
                <p
                  className="text-white text-xs md:text-sm uppercase tracking-wider leading-none mb-1"
                  style={displayFont}
                >
                  {item.label}
                </p>
                <p className="text-zinc-400 text-[11px] md:text-xs leading-tight">
                  {item.detail}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
